"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  LOGO_ALT_TEXT: "Logo",
  LOADING: "Loading chat",
  LOADING_SUBTITLE: "This shouldn't take long..."
};